import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { InformationBoxComponent } from '@principle-theorem/ng-principle-shared';
import { NgDialogModule } from '@principle-theorem/ng-shared';

export enum HealthPointOperationLabel {
  Claim = 'claim',
  Cancellation = 'cancellation',
}

export interface IHealthPointVerificationDialogData {
  operationLabel: HealthPointOperationLabel;
  errorCode: string;
  errorDescription: string;
  refTag: string;
}

@Component({
  selector: 'pr-healthpoint-verification-dialog',
  templateUrl: './healthpoint-verification-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgDialogModule, InformationBoxComponent],
})
export class HealthPointVerificationDialogComponent {
  titleLabel: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: IHealthPointVerificationDialogData
  ) {
    this.titleLabel =
      data.operationLabel === HealthPointOperationLabel.Claim
        ? 'Claim'
        : 'Cancellation';
  }
}
